import { IoMdArrowDropdown } from "react-icons/io";
import {
  Container,
  Area,
  AreaContainer,
  Wrapper,
  PlanInfo,
} from "./index.styled";
import { useCallback, useEffect, useMemo, useState } from "react";
import useOnclickOutside from "react-cool-onclickoutside";
import { Text } from "../common/text/text";
import { useDispatch, useSelector } from "react-redux";
import { AppState } from "../../store/app-state";
import { useTranslation } from "react-i18next";
import { getCurrentPlan } from "../../store/plan/plan-actions";
import { Button } from "../common";
import { useTheme } from "styled-components";
import { usePaywallActionContext } from "../../contexts/paywall";
import { planApi } from "../../api/talent/plan-service";

export const PlanInfos: React.FC = () => {
  const [showDetail, setShowDetail] = useState(false);
  const ref = useOnclickOutside((e) => {
    setShowDetail(false);
  });
  const { data: currentPlan } = useSelector(
    (state: AppState) => state.planState.currentPlan
  );
  const { handleOpen: setOpenPaywall } = usePaywallActionContext();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const theme = useTheme();

  const candidatesPercents = useMemo(() => {
    if (currentPlan && currentPlan.quota_candidates && currentPlan.quota_candidates > 0) {
      const percent =
        (currentPlan.candidates / currentPlan.quota_candidates) * 100;
      return percent > 100 ? 100 : percent.toFixed(2);;
    }
    return 0;
  }, [currentPlan]);

  const usersPercents = useMemo(() => {
    if (currentPlan && currentPlan.quota_users && currentPlan.quota_users > 0) {
      const percent = (currentPlan.users / currentPlan.quota_users) * 100;
      return percent > 100 ? 100 : percent.toFixed(2);;
    }
    return 0;
  }, [currentPlan]);

  const handleOpenPaywall = useCallback(() => {
    setOpenPaywall(true);
    planApi.getNextPlans();
  }, [setOpenPaywall]);

  useEffect(() => {
    dispatch(getCurrentPlan());
  }, [dispatch]);

  const infos = useMemo(() => {
    return (
      <Wrapper>
        <Container
          backgroundColor="rgb(202, 221, 250)"
          borderColor="rgb(111, 188, 235)"
          onClick={() => setShowDetail(!showDetail)}
        >
          {/* <b>{t("private-home-page:headers.plan")}</b>: {currentPlan?.name} */}
          {t("private-home-page:headers.your-plan")}
          <IoMdArrowDropdown size={15} />
        </Container>
        <AreaContainer ref={ref}>
          <Area isShown={showDetail}>
            <PlanInfo>
              <Text as="p" color="#000" margin="10px">
              {t("private-home-page:headers.plan")}: <b>{currentPlan?.name}</b>
              </Text>
            </PlanInfo>
            <PlanInfo>
              <Text as="p" color="#000" margin="10px">
                {t("private-home-page:headers.selective-process")}:{" "}
                <b>
                  {currentPlan?.candidates} {t("private-home-page:headers.of")}{" "}
                  {currentPlan?.quota_candidates} {`(${candidatesPercents}%)`}
                </b>
              </Text>
            </PlanInfo>
            <PlanInfo>
              <Text as="p" color="#000" margin="10px">
                {t("private-home-page:headers.active-users")}:{" "}
                <b>
                  {currentPlan?.users} {t("private-home-page:headers.of")}{" "}
                  {currentPlan?.quota_users} {`(${usersPercents}%)`}
                </b>
              </Text>
            </PlanInfo>
            <PlanInfo>
              <Button
                backgroundColor={theme.colors.primaryBlue.main}
                textColor={theme.colors.primaryBlue.text}
                width="60%"
                margin="15px auto"
                onClick={handleOpenPaywall}
              >
                {t("private-home-page:headers.upgrade-plan")}
              </Button>
            </PlanInfo>
          </Area>
        </AreaContainer>
      </Wrapper>
    );
  }, [t, ref, showDetail, currentPlan?.name, currentPlan?.candidates, currentPlan?.quota_candidates, currentPlan?.users, currentPlan?.quota_users, candidatesPercents, usersPercents, theme.colors.primaryBlue.main, theme.colors.primaryBlue.text, handleOpenPaywall]);

  return (
    <>
      {(currentPlan?.quota_candidates ?? 0) > 0 &&
        (currentPlan?.quota_candidates ?? 0) > 0 &&
        infos}
    </>
  );
};

export default PlanInfos;
